import useStore from "hooks/useStore";
import { FC, ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";

interface Props {
    children: ReactElement
}

const NonProtectedRoutes: FC<Props> = ({ children }) => {
    const {
        getToken,
        getDefaultPathByRole,
        isAuthAccessibleRoute
    } = useStore();
    const token = getToken();
    const { pathname } = useLocation();

    if (token && !isAuthAccessibleRoute(pathname as siteRoutes)) {
        const defaultPath = getDefaultPathByRole();
        return <Navigate to={defaultPath}/>
    }

    return children;
}

export default NonProtectedRoutes;